import React from 'react';
import { useSelector } from 'react-redux';

import { Typography } from '@material-ui/core';

import { convertToEstablishmentName, convertToReal } from 'helpers/converters';
import { formatServicesCategories } from 'helpers/formatters';

const header = [
  { title: 'Categoria do serviço' },
  { title: 'Nome do serviço' },
  { title: 'Preço' },
  { title: 'Situação' }
];

const ServicesExport = React.forwardRef((props, ref) => {
  const { establishmentId } = useSelector(state => state.businessInfo);
  const { establishments } = useSelector(state => state.login);
  const { servicesCategories } = useSelector(state => state.services);

  const establishmentName = convertToEstablishmentName(establishmentId, establishments) || 'Todos os estabelecimentos';

  const formattedData = props?.data?.length > 0 && props?.data?.map(item => {
    return {
      categories: formatServicesCategories(item?.categories, servicesCategories),
      description: item?.description || '-',
      amount: convertToReal(item?.amount || ''),
      status: +item?.status == 1 ? 'Ativado' : 'Desativado'
    }
  });

  return(
    <div ref={ref} style={{ width: '100%', padding: 10 }}>
      <div>
        <Typography variant='h5'>
          Serviços
        </Typography>
      </div>
      <div>
        <Typography>
          {establishmentName}
        </Typography>
      </div>
      <div style={{ width: '100%', marginTop: 20 }}>
        <table style={{ width: '100%', tableLayout: 'fixed', border: '1px solid #000000', borderCollapse: 'collapse' }}>
          <tr style={{ width: '100%', borderBottom: 'thin solid' }}>
            {header.map(item => (
              <th style={{ borderRight: 'thin solid', textAlign: 'left', padding: 5 }}>
                {item.title}
              </th>
            ))}
          </tr>
          {formattedData?.length > 0 && formattedData?.map(item => (
            <tr style={{ width: '100%', borderBottom: 'thin solid' }}>
              <td style={{ borderRight: 'thin solid', color: '#505050', padding: 5, wordWrap: 'break-word' }}>{item?.categories}</td>
              <td style={{ borderRight: 'thin solid', color: '#505050', padding: 5, wordWrap: 'break-word' }}>{item?.description}</td>
              <td style={{ borderRight: 'thin solid', color: '#505050', padding: 5, wordWrap: 'break-word' }}>{item?.amount}</td>
              <td style={{ borderRight: 'thin solid', color: '#505050', padding: 5, wordWrap: 'break-word' }}>{item?.status}</td>
            </tr>
          ))}
        </table>
      </div>
    </div>
  );
});

export default ServicesExport;